module.exports = __webpack_public_path__ + "static/media/25.ec803f95.jpg";